import { Sun, Moon, MonitorSmartphone, Check } from "lucide-react";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "./ui/dropdown-menu";
import { useTheme } from "../lib/theme";

const OPTS = [["dark", "Dark", Moon], ["light", "Light", Sun], ["auto", "Auto (device)", MonitorSmartphone]];

export function ThemeSegment({ testid = "menu-theme" }) {
  const { pref, setPref } = useTheme();
  return (
    <div className="grid grid-cols-3 gap-1 rounded-full border border-white/10 p-1" data-testid={testid}>
      {OPTS.map(([v, l, I]) => (
        <button key={v} type="button" onClick={() => setPref(v)} data-testid={`${testid}-${v}`}
          className={`flex items-center justify-center gap-1.5 rounded-full py-1.5 text-xs font-semibold transition-colors ${pref === v ? "text-black" : "text-gray-300 hover:text-[#E5C158]"}`}
          style={pref === v ? { background: "var(--gold-grad)" } : {}}><I className="w-3.5 h-3.5" />{l.split(" ")[0]}</button>
      ))}
    </div>
  );
}

export default function ThemeToggle({ testid = "theme-toggle", className = "w-9 h-9" }) {
  const { pref, resolved, setPref } = useTheme();
  const Icon = pref === "auto" ? MonitorSmartphone : resolved === "light" ? Sun : Moon;
  return (
    <DropdownMenu modal={false}>
      <DropdownMenuTrigger asChild>
        <button aria-label="Change theme" title="Theme" className={`${className} rounded-full border border-white/10 hover:border-[#D4AF37]/60 flex items-center justify-center text-[#E5C158] transition-colors`} data-testid={testid}>
          <Icon className="w-4 h-4" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="min-w-[170px]" data-testid={`${testid}-menu`}>
        {OPTS.map(([v, l, I]) => (
          <DropdownMenuItem key={v} onSelect={() => setPref(v)} className="gap-2 cursor-pointer" data-testid={`${testid}-${v}`}>
            <I className="w-4 h-4 text-[#D4AF37]" />{l}{pref === v && <Check className="w-3.5 h-3.5 ml-auto text-[#D4AF37]" />}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
